import React from 'react'
import InformationPanel from './InformationPanel/index'
import type { TitleDescription } from './InformationPanel'
import { styled, Fold } from '~/app/components'
import SubHeader from '~/app/components/common/SubHeader/SubHeader'

/**
 * UserInformation component
 * author: soojin.oh
 */

// type definitions
type UserInformationProps = {
  user: Array<TitleDescription>
  isDisabledFold?: boolean
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'style'>

// styled components
const Container = styled.div`
  position: relative;
`

const FoldWithoutShadow = styled(Fold)`
  box-shadow: none !important;
`

const DisabledFoldWrapper = styled.div`
  padding-bottom: 1.2rem;
  background: ${({ theme }) => theme.color.white};
  border-bottom: 1px solid ${({ theme }) => theme.color.gray200};
`
// UserInformation component
const UserInformation: React.FunctionComponent<UserInformationProps> = function ({
  user,
  style,
  isDisabledFold,
}) {
  return isDisabledFold ? (
    <Container style={style}>
      <DisabledFoldWrapper>
        <SubHeader title="예약자 정보" hasBottomContent />
        <InformationPanel information={user} />
      </DisabledFoldWrapper>
    </Container>
  ) : (
    <Container style={style}>
      <FoldWithoutShadow title={'예약자 정보'} initFolded={true}>
        <div style={{ paddingBottom: '1.2rem' }}>
          <InformationPanel information={user} />
        </div>
      </FoldWithoutShadow>
    </Container>
  )
}

export default UserInformation
